/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intro_Pool_Size_All_DescriptionInputs */

const en_intro_pool_size_all_description = /** @type {(inputs: Intro_Pool_Size_All_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every available country in a single full pool.`)
};

/** @type {(inputs: Intro_Pool_Size_All_DescriptionInputs) => LocalizedString} */
const bn_intro_pool_size_all_description = en_intro_pool_size_all_description;

/** @type {(inputs: Intro_Pool_Size_All_DescriptionInputs) => LocalizedString} */
const de_intro_pool_size_all_description = en_intro_pool_size_all_description;

/** @type {(inputs: Intro_Pool_Size_All_DescriptionInputs) => LocalizedString} */
const el_intro_pool_size_all_description = en_intro_pool_size_all_description;

/** @type {(inputs: Intro_Pool_Size_All_DescriptionInputs) => LocalizedString} */
const es_intro_pool_size_all_description = en_intro_pool_size_all_description;

/** @type {(inputs: Intro_Pool_Size_All_DescriptionInputs) => LocalizedString} */
const fr_intro_pool_size_all_description = en_intro_pool_size_all_description;

/** @type {(inputs: Intro_Pool_Size_All_DescriptionInputs) => LocalizedString} */
const hi_intro_pool_size_all_description = en_intro_pool_size_all_description;

/** @type {(inputs: Intro_Pool_Size_All_DescriptionInputs) => LocalizedString} */
const hu_intro_pool_size_all_description = en_intro_pool_size_all_description;

/** @type {(inputs: Intro_Pool_Size_All_DescriptionInputs) => LocalizedString} */
const id_intro_pool_size_all_description = en_intro_pool_size_all_description;

/** @type {(inputs: Intro_Pool_Size_All_DescriptionInputs) => LocalizedString} */
const it_intro_pool_size_all_description = en_intro_pool_size_all_description;

/** @type {(inputs: Intro_Pool_Size_All_DescriptionInputs) => LocalizedString} */
const ja_intro_pool_size_all_description = en_intro_pool_size_all_description;

/** @type {(inputs: Intro_Pool_Size_All_DescriptionInputs) => LocalizedString} */
const ko_intro_pool_size_all_description = en_intro_pool_size_all_description;

/** @type {(inputs: Intro_Pool_Size_All_DescriptionInputs) => LocalizedString} */
const nl_intro_pool_size_all_description = en_intro_pool_size_all_description;

/** @type {(inputs: Intro_Pool_Size_All_DescriptionInputs) => LocalizedString} */
const pl_intro_pool_size_all_description = en_intro_pool_size_all_description;

/** @type {(inputs: Intro_Pool_Size_All_DescriptionInputs) => LocalizedString} */
const pt_intro_pool_size_all_description = en_intro_pool_size_all_description;

/** @type {(inputs: Intro_Pool_Size_All_DescriptionInputs) => LocalizedString} */
const ru_intro_pool_size_all_description = en_intro_pool_size_all_description;

/** @type {(inputs: Intro_Pool_Size_All_DescriptionInputs) => LocalizedString} */
const sv_intro_pool_size_all_description = en_intro_pool_size_all_description;

/** @type {(inputs: Intro_Pool_Size_All_DescriptionInputs) => LocalizedString} */
const tr_intro_pool_size_all_description = en_intro_pool_size_all_description;

/** @type {(inputs: Intro_Pool_Size_All_DescriptionInputs) => LocalizedString} */
const uk_intro_pool_size_all_description = en_intro_pool_size_all_description;

/** @type {(inputs: Intro_Pool_Size_All_DescriptionInputs) => LocalizedString} */
const vi_intro_pool_size_all_description = en_intro_pool_size_all_description;

/** @type {(inputs: Intro_Pool_Size_All_DescriptionInputs) => LocalizedString} */
const zh_intro_pool_size_all_description = en_intro_pool_size_all_description;

/** @type {(inputs: Intro_Pool_Size_All_DescriptionInputs) => LocalizedString} */
const zh_hant_intro_pool_size_all_description = zh_intro_pool_size_all_description;

/**
* | output |
* | --- |
* | "Every available country in a single full pool." |
*
* @param {Intro_Pool_Size_All_DescriptionInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const intro_pool_size_all_description = /** @type {((inputs?: Intro_Pool_Size_All_DescriptionInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intro_Pool_Size_All_DescriptionInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_intro_pool_size_all_description(inputs)
	if (locale === "de") return de_intro_pool_size_all_description(inputs)
	if (locale === "el") return el_intro_pool_size_all_description(inputs)
	if (locale === "en") return en_intro_pool_size_all_description(inputs)
	if (locale === "es") return es_intro_pool_size_all_description(inputs)
	if (locale === "fr") return fr_intro_pool_size_all_description(inputs)
	if (locale === "hi") return hi_intro_pool_size_all_description(inputs)
	if (locale === "hu") return hu_intro_pool_size_all_description(inputs)
	if (locale === "id") return id_intro_pool_size_all_description(inputs)
	if (locale === "it") return it_intro_pool_size_all_description(inputs)
	if (locale === "ja") return ja_intro_pool_size_all_description(inputs)
	if (locale === "ko") return ko_intro_pool_size_all_description(inputs)
	if (locale === "nl") return nl_intro_pool_size_all_description(inputs)
	if (locale === "pl") return pl_intro_pool_size_all_description(inputs)
	if (locale === "pt") return pt_intro_pool_size_all_description(inputs)
	if (locale === "ru") return ru_intro_pool_size_all_description(inputs)
	if (locale === "sv") return sv_intro_pool_size_all_description(inputs)
	if (locale === "tr") return tr_intro_pool_size_all_description(inputs)
	if (locale === "uk") return uk_intro_pool_size_all_description(inputs)
	if (locale === "vi") return vi_intro_pool_size_all_description(inputs)
	if (locale === "zh") return zh_intro_pool_size_all_description(inputs)
	return zh_hant_intro_pool_size_all_description(inputs)
});